/*eslint-disable*/
import React from "react";
import { useHistory } from 'react-router-dom';
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ClassTest from '../LandingPage/Sections/ClassTest.js';
import authService from '../../../components/api-authorization/AuthorizeService'


// core components

import HeaderLinks from "components/Header/HeaderLinks.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Parallax from "components/Parallax/Parallax.js";
import Footer from "components/Footer/Footer.js";
import Button from "components/CustomButtons/Button.js";
import { ToastContainer, toast } from 'react-toastify';

// views for this page
import RecentOrdersSection from "trade-customer-portal/views/LandingPage/Sections/RecentOrders.js"
import ContactInfo from "trade-customer-portal/views/LandingPage/Sections/ContactUsSection.js";
import FooterSection from "trade-customer-portal/views/footer.js"
import HeaderSection from "trade-customer-portal/views/header.js";
import NotificationBanner from "trade-customer-portal/views/NotificationBanner.js";


// styling 
import landingPageStyle from "assets/jss/CustomerTradePortal/views/landingPageStyle.js";
import CreateOrderButton from "../OrderProcessPage/Sections/CreateOrderButton.js";
import ViewOrderButton from "../OrderProcessPage/Sections/ViewOrderButton";
import { infoColor } from "assets/jss/material-kit-pro-react.js";
const useStyles = makeStyles(landingPageStyle);

// Landing Page for customer trade portal 
export default function LandingPage() {
    React.useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
    });
    const history = useHistory();
    const classes = useStyles();


    const [notificationUrl, setNotificationUrl] = React.useState(null);

    //const handleShowNotification = () => {
    //    setNotificationText("News: Bagging products!");
    //    setTimeout(() => {
    //        setNotificationText(null);
    //    }, 50000);
    //};

    //React.useEffect(() => {
    //    handleShowNotification();
    //}, []);


    React.useEffect(() => {

        getTickerText();

        async function getTickerText() {

            try {
                const token = await authService.getAccessToken();

                const response = await fetch('api/data/gettickertext/', {
                    method: 'get',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`
                    }
                });

                const res = await response.json();
                setNotificationUrl(res.url);
                displayNote(res.message);
            }
            catch (e) {

            }



        };

    }, [])

    const displayNote = (msg) => toast.info(msg, {
        position: "top-right",
        autoClose: 7000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
    })


    return (
        <div >
                <div>
                    <ToastContainer
                        position="bottom-right"
                        autoClose={5000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />

                </div>
            <HeaderSection isLandingPage={true} />
            {/* <Parallax
                image={require("assets/img/cadebyDepot.jpg")}
                filter="dark"
                small
            > */}

                {/* <div className={classes.container}>
                    <GridContainer justify="center">
                        <GridItem
                            md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title}>Easi Order Portal </h1>

                            <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
                                <CreateOrderButton />
                                <ViewOrderButton />
                            </div>

                        </GridItem>
                        <GridItem md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >

                            <div className={classes.inlineBlock}>
                                <a href="https://www.youtube.com/watch?v=8oTMGPAqZYk" target="_blank" rel="noopener noreferrer" >
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-youtube" style={{ color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://x.com/FPMcCann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fa-brands fa-x-twitter" style={{ color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://www.instagram.com/fpmccann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-instagram" style={{ color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://m.facebook.com/FP-McCann-110181082374851/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-facebook" style={{ color: infoColor[1] }} />
                                    </Button>
                                </a>
                                <a href="https://www.linkedin.com/company/fp-mccann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-linkedin-in" style={{ color: infoColor[1] }}></i>
                                    </Button>
                                </a>
                            </div>
                        </GridItem>
                    </GridContainer>

                </div> */}
            {/* </Parallax> */}
            <div className={classNames(classes.main, classes.landingPageMainRaised)} >
                <div className={classes.container} >
                <GridContainer justify="center">
                        <GridItem
                            md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >
                            <h1 className={classes.title}>EASI ORDER PORTAL</h1>

                        </GridItem>
                        <GridItem
                            md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter,
                                classes.paddingY
                            )}
                        >
                            <div style={{ display: 'flex', gap: '2rem', justifyContent: 'center' }}>
                                <CreateOrderButton />
                                <ViewOrderButton />
                            </div>

                        </GridItem>
                        <GridItem md={7}
                            sm={8}
                            className={classNames(
                                classes.mlAuto,
                                classes.mrAuto,
                                classes.textCenter
                            )}
                        >

                            <div className={classes.inlineBlock} style={{ display: 'flex', gap: '20px', justifyContent: 'center' }}>
                                <a href="https://www.youtube.com/watch?v=8oTMGPAqZYk" target="_blank" rel="noopener noreferrer" >
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-youtube" style={{ fontSize: "35px", color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://x.com/FPMcCann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fa-brands fa-x-twitter" style={{ fontSize: "35px", color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://www.instagram.com/fpmccann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-instagram" style={{ fontSize: "35px", color: infoColor[1] }} />
                                    </Button>
                                </a>

                                <a href="https://m.facebook.com/FP-McCann-110181082374851/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-facebook" style={{ fontSize: "35px", color: infoColor[1] }} />
                                    </Button>
                                </a>
                                <a href="https://www.linkedin.com/company/fp-mccann/" target="_blank" rel="noopener noreferrer">
                                    <Button justIcon simple color="white">
                                        <i className="fab fa-linkedin-in" style={{ fontSize: "35px", color: infoColor[1] }}></i>
                                    </Button>
                                </a>
                            </div>
                        </GridItem>
                    </GridContainer>

                {/* <div style={{ display: "flex", gap: "16px", justifyContent: "center", paddingTop: "2rem" }}>
                        <img style={{ width: "60%" }} src={multiLoadOffering} alt="Multi Load Offering" />
                    </div>
                    <h5 className={classes.description} style={{ padding: "40px 0 0 0", textAlign: "justify" }}>
                        <b> FP McCann will deliver to locations throughout the UK/Ireland and our sales and technical teams are on hand to discuss your requirements. </b>
                    </h5> */}
                    <br />
                    <br />
                    {/*<ContactInfo />*/}
                    <br />
                </div>
            </div>
            {/* <FooterSection /> */}

            <div>
                {notificationUrl && <NotificationBanner url={notificationUrl} type="walkthrough" />}
            </div>
        </div>
    );
}
